export enum AuthTemplates {
  summit = "summit",
  manager = "manager",
}
